import { uiText } from '../../i18n/uiText';
import React from 'react';
import {
  formatRussianPhone,
  RUSSIAN_PHONE_PATTERN,
  RUSSIAN_PHONE_PLACEHOLDER,
  russianPhoneDigits,
} from '../../utils/phone';

export default function RussianPhoneInput({
  value,
  onValueChange,
  className = 'form-control',
  autoComplete = 'tel',
  onFocus,
  onBlur,
  onPaste,
  ...props
}) {
  const handleFocus = (event) => {
    if (!russianPhoneDigits(value).length) onValueChange?.('+7 ');
    onFocus?.(event);
  };

  const handleBlur = (event) => {
    if (!russianPhoneDigits(value).length) onValueChange?.('');
    onBlur?.(event);
  };

  const handlePaste = (event) => {
    const pasted = event.clipboardData?.getData('text');
    if (pasted) {
      event.preventDefault();
      onValueChange?.(formatRussianPhone(pasted));
    }
    onPaste?.(event);
  };

  return (
    <input
      {...props}
      className={className}
      type="tel"
      inputMode="numeric"
      autoComplete={autoComplete}
      pattern={RUSSIAN_PHONE_PATTERN}
      title={uiText("Введите российский номер полностью: +7 xxx-xxx-xx-xx")}
      placeholder={RUSSIAN_PHONE_PLACEHOLDER}
      value={formatRussianPhone(value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onPaste={handlePaste}
      onChange={(event) => onValueChange?.(
        formatRussianPhone(event.target.value, { showPrefixForEmpty: true })
      )}
    />
  );
}
